import React, { useState, useEffect } from 'react';
import inspectionStorage from '../services/inspectionStorage';
import syncManager from '../services/syncManager';
import pendingPhotosService from '../services/pendingPhotosService';
import QuickPhotoButton from './QuickPhotoButton';
import './Etape10.css';
import EquipmentCategoryModal from './modals/EquipmentCategoryModal';
import LuminaireModal from './modals/LuminaireModal';
import EclairageSecuriteModal from './modals/EclairageSecuriteModal';
import PriseCourantModal from './modals/PriseCourantModal';
import MaterielInfoModal from './modals/MaterielInfoModal';
import MaterielAmovibleModal from './modals/MaterielAmovibleModal';
import RecepteursFixesModal from './modals/RecepteursFixesModal';
import MaterielPortatifModal from './modals/MaterielPortatifModal';
import MachineGarageModal from './modals/MachineGarageModal';
import MaterielIndustrielModal from './modals/MaterielIndustrielModal';
import MachineCEModal from './modals/MachineCEModal';
import DDRCircuitsTerminauxModal from './modals/DDRCircuitsTerminauxModal';
import AutreEquipementModal from './modals/AutreEquipementModal';
import DuplicateLocalModal from './modals/DuplicateLocalModal';
import ObservationModal from './modals/ObservationModal';
import ImportLocalisationsModal from './modals/ImportLocalisationsModal';
import EssaiArretUrgenceModal from './modals/EssaiArretUrgenceModal';

export default function Etape10({ mission, onComplete, onBack }) {
  const [groupes, setGroupes] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  
  // Modals et états
  const [showGroupeModal, setShowGroupeModal] = useState(false);
  const [showBatimentModal, setShowBatimentModal] = useState(false);
  const [showLocalModal, setShowLocalModal] = useState(false);
  const [showCategoryModal, setShowCategoryModal] = useState(false);
  const [showDuplicateModal, setShowDuplicateModal] = useState(false);
  const [showObservationModal, setShowObservationModal] = useState(false);
  const [showArretUrgenceModal, setShowArretUrgenceModal] = useState(false);
  const [showImportModal, setShowImportModal] = useState(false);
  
  const [currentGroupeIndex, setCurrentGroupeIndex] = useState(null);
  const [currentBatimentIndex, setCurrentBatimentIndex] = useState(null);
  const [currentLocalIndex, setCurrentLocalIndex] = useState(null);
  const [editingGroupeIndex, setEditingGroupeIndex] = useState(null);
  const [editingBatimentIndex, setEditingBatimentIndex] = useState(null);
  const [editingLocalIndex, setEditingLocalIndex] = useState(null);
  
  const [newGroupe, setNewGroupe] = useState('');
  const [newBatiment, setNewBatiment] = useState('');
  const [currentLocal, setCurrentLocal] = useState({
    nom: '',
    description: '',
    equipements: []
  });
  
  const [selectedLocal, setSelectedLocal] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [editingEquipment, setEditingEquipment] = useState(null);
  const [editingEquipmentIndex, setEditingEquipmentIndex] = useState(null);
  const [observationContext, setObservationContext] = useState(null);
  const [obsInitialPhotos, setObsInitialPhotos] = useState([]);
  const [obsPendingPhotoId, setObsPendingPhotoId] = useState(null);
  const [duplicatingLocal, setDuplicatingLocal] = useState(null);

  useEffect(() => {
    loadData();
  }, [mission]);

  const loadData = async () => {
    try {
      const savedData = await inspectionStorage.getStep(mission.id, 'etape_10_localisations');
      if (savedData?.zones_verifiees) {
        const localisations = savedData.zones_verifiees;
        
        // 🔥 DÉTECTER SI STRUCTURE HIÉRARCHIQUE OU ANCIENNE
        const isHierarchical = localisations.length > 0 && 
          localisations[0].groupe_localisation !== undefined && 
          localisations[0].sous_categories !== undefined;
        
        if (isHierarchical) {
          setGroupes(localisations);
        } else if (localisations.length > 0) {
          // 🔄 MIGRATION AUTOMATIQUE vers structure hiérarchique
          console.log('🔄 Migration de l\'ancienne structure vers hiérarchique');
          const migratedData = [{
            groupe_localisation: 'LOCAUX EXISTANTS',
            sous_categories: [{
              nom: 'GÉNÉRAL',
              locaux: localisations.map(local => ({
                nom: local.nom,
                description: local.description || '',
                equipements: local.equipements || []
              }))
            }]
          }];
          setGroupes(migratedData);
          await saveData(migratedData);
        }
      }
    } catch (error) {
      console.error('❌ Erreur chargement données:', error);
    }
  };

  const saveData = async (groupesData) => {
    setIsSaving(true);
    try {
      // Fusionner avec l'existant pour ne pas ecraser d'autres champs
      // (par exemple essais_arret_urgence, qui sont stockes dans la meme etape)
      const currentData = (await inspectionStorage.getStep(mission.id, 'etape_10_localisations')) || {};
      const stepData = {
        ...currentData,
        zones_verifiees: groupesData,
        timestamp: new Date().toISOString()
      };
      
      await inspectionStorage.saveStep(mission.id, 'etape_10_localisations', stepData);
      syncManager.syncStep(mission.id, 'etape_10_localisations', stepData);
      
      console.log('✅ Locaux sauvegardés');
    } catch (error) {
      console.error('❌ Erreur sauvegarde:', error);
      alert('Erreur lors de la sauvegarde');
    } finally {
      setIsSaving(false);
    }
  };

  // ========== GESTION GROUPES ==========
  const handleAddGroupe = () => {
    if (!newGroupe.trim()) return;

    const updatedGroupes = [...groupes];
    
    if (editingGroupeIndex !== null) {
      updatedGroupes[editingGroupeIndex].groupe_localisation = newGroupe;
    } else {
      updatedGroupes.push({
        groupe_localisation: newGroupe,
        sous_categories: []
      });
    }

    setGroupes(updatedGroupes);
    saveData(updatedGroupes);
    setNewGroupe('');
    setEditingGroupeIndex(null);
    setShowGroupeModal(false);
  };

  const handleDeleteGroupe = (groupeIndex) => {
    if (!window.confirm('Supprimer ce groupe et tous ses locaux ?')) return;
    
    const updatedGroupes = groupes.filter((_, i) => i !== groupeIndex);
    setGroupes(updatedGroupes);
    saveData(updatedGroupes);
  };

  // ========== GESTION BÂTIMENTS ==========
  const handleAddBatiment = () => {
    if (!newBatiment.trim() || currentGroupeIndex === null) return;

    const updatedGroupes = [...groupes];
    
    if (editingBatimentIndex !== null) {
      updatedGroupes[currentGroupeIndex].sous_categories[editingBatimentIndex].nom = newBatiment;
    } else {
      updatedGroupes[currentGroupeIndex].sous_categories.push({
        nom: newBatiment,
        locaux: []
      });
    }

    setGroupes(updatedGroupes);
    saveData(updatedGroupes);
    setNewBatiment('');
    setEditingBatimentIndex(null);
    setShowBatimentModal(false);
    setCurrentGroupeIndex(null);
  };

  const handleDeleteBatiment = (groupeIndex, batimentIndex) => {
    if (!window.confirm('Supprimer ce bâtiment et tous ses locaux ?')) return;
    
    const updatedGroupes = [...groupes];
    updatedGroupes[groupeIndex].sous_categories = 
      updatedGroupes[groupeIndex].sous_categories.filter((_, i) => i !== batimentIndex);

    setGroupes(updatedGroupes);
    saveData(updatedGroupes);
  };

  // ========== GESTION LOCAUX ==========
  const handleSaveLocal = () => {
    if (!currentLocal.nom.trim()) return;

    const updatedGroupes = [...groupes];
    
    if (editingLocalIndex !== null) {
      updatedGroupes[currentGroupeIndex].sous_categories[currentBatimentIndex].locaux[editingLocalIndex] = {
        ...updatedGroupes[currentGroupeIndex].sous_categories[currentBatimentIndex].locaux[editingLocalIndex],
        nom: currentLocal.nom,
        description: currentLocal.description
      };
    } else {
      updatedGroupes[currentGroupeIndex].sous_categories[currentBatimentIndex].locaux.push({
        ...currentLocal,
        equipements: []
      });
    }

    setGroupes(updatedGroupes);
    saveData(updatedGroupes);
    setCurrentLocal({ nom: '', description: '', equipements: [] });
    setEditingLocalIndex(null);
    setShowLocalModal(false);
    setCurrentGroupeIndex(null);
    setCurrentBatimentIndex(null);
  };

  const handleDeleteLocal = (groupeIndex, batimentIndex, localIndex) => {
    if (!window.confirm('Supprimer ce local et tous ses équipements ?')) return;
    
    const updatedGroupes = [...groupes];
    updatedGroupes[groupeIndex].sous_categories[batimentIndex].locaux = 
      updatedGroupes[groupeIndex].sous_categories[batimentIndex].locaux.filter((_, i) => i !== localIndex);

    setGroupes(updatedGroupes);
    saveData(updatedGroupes);
  };

  // ========== GESTION ÉQUIPEMENTS ==========
  const openEquipmentCategory = (groupeIndex, batimentIndex, localIndex) => {
    const local = groupes[groupeIndex].sous_categories[batimentIndex].locaux[localIndex];
    setSelectedLocal({ 
      ...local, 
      groupeIndex, 
      batimentIndex, 
      localIndex 
    });
    setShowCategoryModal(true);
  };

  const handleSelectCategory = (categoryId) => {
    setSelectedCategory(categoryId);
    setShowCategoryModal(false);
  };

  const handleSaveEquipment = (equipment) => {
    if (!selectedLocal) return;
    
    const updatedGroupes = [...groupes];
    const { groupeIndex, batimentIndex, localIndex } = selectedLocal;
    
    if (!updatedGroupes[groupeIndex].sous_categories[batimentIndex].locaux[localIndex].equipements) {
      updatedGroupes[groupeIndex].sous_categories[batimentIndex].locaux[localIndex].equipements = [];
    }
    
    if (editingEquipmentIndex !== null) {
      updatedGroupes[groupeIndex].sous_categories[batimentIndex].locaux[localIndex].equipements[editingEquipmentIndex] = equipment;
      setEditingEquipment(null);
      setEditingEquipmentIndex(null);
    } else {
      updatedGroupes[groupeIndex].sous_categories[batimentIndex].locaux[localIndex].equipements.push({ 
        ...equipment, 
        obs_ids: [] 
      });
    }
    
    setGroupes(updatedGroupes);
    saveData(updatedGroupes);
    setSelectedCategory(null);
    setSelectedLocal(null);
  };

  const handleEditEquipment = (groupeIndex, batimentIndex, localIndex, equipment, equipmentIndex) => {
    const local = groupes[groupeIndex].sous_categories[batimentIndex].locaux[localIndex];
    setEditingEquipment(equipment);
    setEditingEquipmentIndex(equipmentIndex);
    setSelectedLocal({ 
      ...local, 
      groupeIndex, 
      batimentIndex, 
      localIndex 
    });
    
    const category = equipment.category || equipment.type;
    setSelectedCategory(category);
  };

  const handleDeleteEquipment = (groupeIndex, batimentIndex, localIndex, equipmentIndex) => {
    if (!window.confirm('Supprimer cet équipement ?')) return;
    
    const updatedGroupes = [...groupes];
    updatedGroupes[groupeIndex].sous_categories[batimentIndex].locaux[localIndex].equipements = 
      updatedGroupes[groupeIndex].sous_categories[batimentIndex].locaux[localIndex].equipements.filter((_, i) => i !== equipmentIndex);
    
    setGroupes(updatedGroupes);
    saveData(updatedGroupes);
  };

  const handleCloseEquipmentModal = () => {
    setSelectedCategory(null);
    setEditingEquipment(null);
    setEditingEquipmentIndex(null);
    if (selectedLocal) {
      setShowCategoryModal(true);
    } else {
      setShowCategoryModal(false);
    }
  };

  // ========== GESTION OBSERVATIONS ==========
  const buildObsContext = (groupeIndex, batimentIndex, localIndex, equipment = null, equipmentIndex = null) => {
    const local = groupes[groupeIndex]?.sous_categories?.[batimentIndex]?.locaux?.[localIndex];
    return {
      step_origin: 'etape_10_localisations',
      localisation: local?.nom || 'NON DÉFINI',
      element: equipment ? (equipment.designation || equipment.type) : 'Local',
      element_ref: {
        etape: '10',
        type: equipment ? 'equipement' : 'local',
        path: equipment
          ? { groupe_index: groupeIndex, batiment_index: batimentIndex, local_index: localIndex, equipment_index: equipmentIndex }
          : { groupe_index: groupeIndex, batiment_index: batimentIndex, local_index: localIndex },
      },
    };
  };

  const openObsModalWith = (ctx, initialPhotos = [], pendingPhotoId = null) => {
    setObservationContext(ctx);
    setObsInitialPhotos(initialPhotos);
    setObsPendingPhotoId(pendingPhotoId);
    setShowObservationModal(true);
  };

  const openObservationModal = (groupeIndex, batimentIndex, localIndex, equipment = null, equipmentIndex = null) => {
    openObsModalWith(buildObsContext(groupeIndex, batimentIndex, localIndex, equipment, equipmentIndex));
  };

  const handleQuickPhotoOpenObs = (photo, ctx) => {
    if (!photo) return;
    const url = photo.url || photo.blob_base64;
    openObsModalWith(ctx, url ? [url] : [], photo.id);
  };

  const handleCloseObsModal = () => {
    setShowObservationModal(false);
    setObservationContext(null);
    setObsInitialPhotos([]);
    setObsPendingPhotoId(null);
  };

  const handleSaveObservation = async (observationData) => {
    try {
      const etape11Data = await inspectionStorage.getStep(mission.id, 'etape_11_observations') || {};
      const currentObservations = etape11Data.observations || [];
      
      const dernierNumero = currentObservations.length > 0
        ? Math.max(...currentObservations.map(o => o.numero || 0))
        : 0;
      const nouveauNumero = dernierNumero + 1;
      
      const observation = {
        ...observationData,
        numero: nouveauNumero,
        created_date: observationData.created_date || new Date().toISOString(),
        photos: observationData.photos || []
      };
      
      const updatedObservations = [...currentObservations, observation];
      
      const obsStepData = {
        observations: updatedObservations,
        dernier_numero: nouveauNumero,
        timestamp: new Date().toISOString()
      };
      
      await inspectionStorage.saveStep(mission.id, 'etape_11_observations', obsStepData);
      syncManager.syncStep(mission.id, 'etape_11_observations', obsStepData);

      // 🔥 LIER OBSERVATION À L'ÉQUIPEMENT (obs_ids)
      if (observation.element_ref) {
        const { etape, type, path } = observation.element_ref;
        if (etape === '10' && type === 'equipement' && path.equipment_index !== undefined) {
          const updatedGroupes = [...groupes];
          const local = updatedGroupes[path.groupe_index]?.sous_categories?.[path.batiment_index]?.locaux?.[path.local_index];
          if (local?.equipements?.[path.equipment_index]) {
            const equipment = { ...local.equipements[path.equipment_index] };
            if (!equipment.obs_ids) equipment.obs_ids = [];
            if (!equipment.obs_ids.includes(nouveauNumero)) {
              equipment.obs_ids.push(nouveauNumero);
            }
            local.equipements[path.equipment_index] = equipment;
            setGroupes(updatedGroupes);
            await saveData(updatedGroupes);
          }
        }
      }

      // 🔥 LIEN AVEC ÉTAPE 14 (NFC 15-100)
      if (observation.lien_etape_14) {
        const etape14Data = await inspectionStorage.getStep(mission.id, 'etape_14_examens_conformite') || {};
        
        if (!etape14Data.nfc_15_100) {
          etape14Data.nfc_15_100 = { articles: {} };
        }
        if (!etape14Data.nfc_15_100.articles) {
          etape14Data.nfc_15_100.articles = {};
        }
        
        etape14Data.nfc_15_100.articles[observation.lien_etape_14] = {
          status: 'NC',
          obs_id: nouveauNumero.toString()
        };

        await inspectionStorage.saveStep(mission.id, 'etape_14_examens_conformite', etape14Data);
        syncManager.syncStep(mission.id, 'etape_14_examens_conformite', etape14Data);
      }

      console.log('✅ Observation sauvegardée:', nouveauNumero);

      if (obsPendingPhotoId) {
        try {
          await pendingPhotosService.remove(mission.id, obsPendingPhotoId);
        } catch (e) {
          console.warn('[Etape10] suppression pending photo échouée :', e?.message || e);
        }
      }

      alert(`✅ Observation N°${nouveauNumero} créée avec succès !`);
    } catch (error) {
      console.error('❌ Erreur sauvegarde observation:', error);
      alert('Erreur lors de la sauvegarde de l\'observation');
    }

    handleCloseObsModal();
  };

  // ========== IMPORT DEPUIS IMAGE/PDF ==========
  const handleImport = (importedData) => {
    const newGroupe = {
      groupe_localisation: 'LOCAUX IMPORTÉS',
      sous_categories: [{
        nom: 'GÉNÉRAL',
        locaux: importedData.multi_locaux 
          ? importedData.locaux.map(l => ({
              nom: l.nom || 'Local importé',
              description: '',
              equipements: l.equipements.map(eq => ({ ...eq, category: eq.type, obs_ids: [] }))
            }))
          : [{
              nom: importedData.local?.nom || 'Local importé',
              description: importedData.local?.ie ? `IE: ${importedData.local.ie}` : '',
              equipements: (importedData.equipements || []).map(eq => ({ ...eq, category: eq.type, obs_ids: [] }))
            }]
      }]
    };

    const updatedGroupes = [...groupes, newGroupe];
    setGroupes(updatedGroupes);
    saveData(updatedGroupes);
  };

  // ========== DUPLICATION LOCAL ==========
  const handleDuplicateLocal = (duplicatedLocal) => {
    const { groupeIndex, batimentIndex } = duplicatingLocal;
    const updatedGroupes = [...groupes];
    
    updatedGroupes[groupeIndex].sous_categories[batimentIndex].locaux.push(duplicatedLocal);

    setGroupes(updatedGroupes);
    saveData(updatedGroupes);
    setShowDuplicateModal(false);
    setDuplicatingLocal(null);
  };

  // ========== HELPERS ==========
  const getEquipmentLabel = (equipment) => {
    return equipment.name || equipment.designation || equipment.nom || equipment.category || equipment.type || 'Équipement';
  };

  const getEquipmentType = (equipment) => {
    return equipment.category || equipment.type || 'Non spécifié';
  };

  const handleComplete = async () => {
    if (groupes.length === 0) {
      alert('Veuillez ajouter au moins un groupe');
      return;
    }
    await saveData(groupes);
    onComplete();
  };

  return (
    <div className="etape10-container">
      <div className="etape10-header">
        <h2 className="etape10-title">🏢 Étape 10</h2>
        <h3 className="etape10-subtitle">Inventaire hiérarchique des locaux</h3>
        {isSaving && <p className="saving-indicator">💾 Sauvegarde en cours...</p>}
      </div>

      <div className="etape10-actions-bar">
        <button
          onClick={() => setShowImportModal(true)}
          className="import-button"
        >
          📸 Importer depuis image/PDF
        </button>
        <button
          onClick={() => setShowGroupeModal(true)}
          className="add-groupe-button"
        >
          + Ajouter un groupe
        </button>
      </div>

      {/* AFFICHAGE DES GROUPES */}
      <div className="groupes-list">
        {groupes.length === 0 ? (
          <div className="empty-state">
            <div className="empty-icon">📍</div>
            <p className="empty-text">Aucun groupe créé</p>
            <button onClick={() => setShowGroupeModal(true)} className="empty-action-button">
              + Créer votre premier groupe
            </button>
          </div>
        ) : (
          groupes.map((groupe, groupeIndex) => (
            <div key={groupeIndex} className="groupe-card">
              {/* EN-TÊTE GROUPE (BLEU) */}
              <div className="groupe-header">
                <h3 className="groupe-title">{groupe.groupe_localisation}</h3>
                <div className="groupe-actions">
                  <button
                    onClick={() => {
                      setCurrentGroupeIndex(groupeIndex);
                      setShowBatimentModal(true);
                    }}
                    className="btn-add-batiment"
                  >
                    + Bâtiment
                  </button>
                  <button
                    onClick={() => {
                      setNewGroupe(groupe.groupe_localisation);
                      setEditingGroupeIndex(groupeIndex);
                      setShowGroupeModal(true);
                    }}
                    className="btn-edit"
                  >
                    ✏️
                  </button>
                  <button
                    onClick={() => handleDeleteGroupe(groupeIndex)}
                    className="btn-delete"
                  >
                    🗑️
                  </button>
                </div>
              </div>

              {/* BÂTIMENTS */}
              {groupe.sous_categories.map((batiment, batimentIndex) => (
                <div key={batimentIndex} className="batiment-section">
                  {/* EN-TÊTE BÂTIMENT (ORANGE) */}
                  <div className="batiment-header">
                    <h4 className="batiment-title">{batiment.nom}</h4>
                    <div className="batiment-actions">
                      <button
                        onClick={() => {
                          setCurrentGroupeIndex(groupeIndex);
                          setCurrentBatimentIndex(batimentIndex);
                          setShowLocalModal(true);
                        }}
                        className="btn-add-local"
                      >
                        + Local
                      </button>
                      <button
                        onClick={() => {
                          setNewBatiment(batiment.nom);
                          setCurrentGroupeIndex(groupeIndex);
                          setEditingBatimentIndex(batimentIndex);
                          setShowBatimentModal(true);
                        }}
                        className="btn-edit-small"
                      >
                        ✏️
                      </button>
                      <button
                        onClick={() => handleDeleteBatiment(groupeIndex, batimentIndex)}
                        className="btn-delete-small"
                      >
                        🗑️
                      </button>
                    </div>
                  </div>

                  {/* LOCAUX */}
                  {batiment.locaux.length === 0 ? (
                    <div className="locaux-empty">
                      Aucun local dans ce bâtiment
                    </div>
                  ) : (
                    <div className="locaux-list">
                      {batiment.locaux.map((local, localIndex) => (
                        <div key={localIndex} className="local-card">
                          <div className="local-header">
                            <div className="local-info">
                              <h5 className="local-name">{local.nom}</h5>
                              {local.description && (
                                <p className="local-description">📍 {local.description}</p>
                              )}
                              <span className="equipements-badge">
                                {local.equipements?.length || 0} équipement(s)
                              </span>
                            </div>
                            <div className="local-header-actions">
                              <button
                                onClick={() => openEquipmentCategory(groupeIndex, batimentIndex, localIndex)}
                                className="btn-add-equipment"
                                title="Ajouter un équipement"
                              >
                                ⚙️
                              </button>
                              <button
                                onClick={() => {
                                  setCurrentLocal({
                                    nom: local.nom,
                                    description: local.description || '',
                                    equipements: local.equipements || []
                                  });
                                  setCurrentGroupeIndex(groupeIndex);
                                  setCurrentBatimentIndex(batimentIndex);
                                  setEditingLocalIndex(localIndex);
                                  setShowLocalModal(true);
                                }}
                                className="btn-edit-small"
                              >
                                ✏️
                              </button>
                              <button
                                onClick={() => {
                                  setDuplicatingLocal({ local, groupeIndex, batimentIndex, localIndex });
                                  setShowDuplicateModal(true);
                                }}
                                className="btn-duplicate"
                                title="Dupliquer le local"
                              >
                                📋
                              </button>
                              <button
                                onClick={() => openObservationModal(groupeIndex, batimentIndex, localIndex)}
                                className="btn-obs"
                              >
                                ⚠️
                              </button>
                              <QuickPhotoButton
                                missionId={mission?.id}
                                context={buildObsContext(groupeIndex, batimentIndex, localIndex)}
                                onOpenObservation={handleQuickPhotoOpenObs}
                                title="Prendre une photo du local"
                              />
                              <button
                                onClick={() => handleDeleteLocal(groupeIndex, batimentIndex, localIndex)}
                                className="btn-delete-small"
                              >
                                🗑️
                              </button>
                            </div>
                          </div>

                          {/* LISTE DES ÉQUIPEMENTS */}
                          {local.equipements && local.equipements.length > 0 && (
                            <div className="equipements-table">
                              <div className="equipements-table-header">
                                <div className="col-equipment">Équipement</div>
                                <div className="col-type">Type</div>
                                <div className="col-qty">Qté</div>
                                <div className="col-protection">Protection</div>
                                <div className="col-pe">PE</div>
                                <div className="col-obs">Obs.</div>
                                <div className="col-actions">Actions</div>
                              </div>
                              {local.equipements.map((equipment, equipmentIndex) => (
                                <div key={equipmentIndex} className="equipements-table-row">
                                  <div className="col-equipment">
                                    {getEquipmentLabel(equipment)}
                                  </div>
                                  <div className="col-type">
                                    <span className="type-badge">{getEquipmentType(equipment)}</span>
                                  </div>
                                  <div className="col-qty">
                                    {equipment.existing_quantity || equipment.verified_quantity || equipment.quantite || '-'}
                                  </div>
                                  <div className="col-protection">
                                    {equipment.protection_type || equipment.protection_tete || equipment.head_protection || '-'}
                                  </div>
                                  <div className="col-pe">
                                    {equipment.continuity_result || equipment.continuite || equipment.continuity || '-'}
                                  </div>
                                  <div className="col-obs">
                                    {equipment.obs_ids && equipment.obs_ids.length > 0 ? (
                                      <span className="obs-count-badge">{equipment.obs_ids.length}</span>
                                    ) : (
                                      <span className="obs-none">-</span>
                                    )}
                                  </div>
                                  <div className="col-actions">
                                    <button
                                      onClick={() => handleEditEquipment(groupeIndex, batimentIndex, localIndex, equipment, equipmentIndex)}
                                      className="btn-action-small"
                                    >
                                      ✏️
                                    </button>
                                    <button
                                      onClick={() => openObservationModal(groupeIndex, batimentIndex, localIndex, equipment, equipmentIndex)}
                                      className="btn-action-small btn-obs"
                                    >
                                      ⚠️
                                    </button>
                                    <QuickPhotoButton
                                      missionId={mission?.id}
                                      context={buildObsContext(groupeIndex, batimentIndex, localIndex, equipment, equipmentIndex)}
                                      onOpenObservation={handleQuickPhotoOpenObs}
                                      title="Prendre une photo de l'équipement"
                                    />
                                    <button
                                      onClick={() => handleDeleteEquipment(groupeIndex, batimentIndex, localIndex, equipmentIndex)}
                                      className="btn-action-small btn-delete"
                                    >
                                      🗑️
                                    </button>
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          ))
        )}
      </div>

      {/* ESSAIS D'ARRÊT D'URGENCE */}
      <div className="arret-urgence-section">
        <button 
          onClick={() => setShowArretUrgenceModal(true)} 
          className="arret-urgence-button"
        >
          🛑 Gestion des Essais d'Arrêt d'Urgence
        </button>
      </div>

      {/* NAVIGATION */}
      <div className="etape10-navigation">
        <button onClick={onBack} className="back-button">
          ← Retour
        </button>
        <button
          onClick={handleComplete}
          disabled={isSaving || groupes.length === 0}
          className="next-button"
        >
          {isSaving ? 'Sauvegarde...' : 'Suivant →'}
        </button>
      </div>

      {/* ========== MODALS ========== */}

      {/* MODAL GROUPE */}
      {showGroupeModal && (
        <div className="modal-overlay" onClick={() => setShowGroupeModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3 className="modal-title">
                {editingGroupeIndex !== null ? 'Modifier' : 'Ajouter'} un groupe
              </h3>
              <button onClick={() => setShowGroupeModal(false)} className="modal-close">✕</button>
            </div>
            <div className="modal-body">
              <div className="form-group">
                <label className="form-label">Nom du groupe (ex: EXTÉRIEUR, BÂTIMENT A)</label>
                <input
                  type="text"
                  value={newGroupe}
                  onChange={(e) => setNewGroupe(e.target.value)}
                  placeholder="Nom du groupe..."
                  className="form-input"
                  autoFocus
                />
              </div>
            </div>
            <div className="modal-footer">
              <button onClick={() => setShowGroupeModal(false)} className="cancel-button">
                Annuler
              </button>
              <button onClick={handleAddGroupe} disabled={!newGroupe.trim()} className="save-button">
                {editingGroupeIndex !== null ? 'Modifier' : 'Ajouter'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* MODAL BÂTIMENT */}
      {showBatimentModal && (
        <div className="modal-overlay" onClick={() => setShowBatimentModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3 className="modal-title">
                {editingBatimentIndex !== null ? 'Modifier' : 'Ajouter'} un bâtiment
              </h3>
              <button onClick={() => setShowBatimentModal(false)} className="modal-close">✕</button>
            </div>
            <div className="modal-body">
              <div className="form-group">
                <label className="form-label">Nom du bâtiment (ex: RDC, ÉTAGE 1)</label>
                <input
                  type="text"
                  value={newBatiment}
                  onChange={(e) => setNewBatiment(e.target.value)}
                  placeholder="Nom du bâtiment..."
                  className="form-input"
                  autoFocus
                />
              </div>
            </div>
            <div className="modal-footer">
              <button onClick={() => setShowBatimentModal(false)} className="cancel-button">
                Annuler
              </button>
              <button onClick={handleAddBatiment} disabled={!newBatiment.trim()} className="save-button">
                {editingBatimentIndex !== null ? 'Modifier' : 'Ajouter'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* MODAL LOCAL */}
      {showLocalModal && (
        <div className="modal-overlay" onClick={() => setShowLocalModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3 className="modal-title">
                {editingLocalIndex !== null ? 'Modifier' : 'Ajouter'} un local
              </h3>
              <button onClick={() => setShowLocalModal(false)} className="modal-close">✕</button>
            </div>
            <div className="modal-body">
              <div className="form-group">
                <label className="form-label">Nom du local *</label>
                <input
                  type="text"
                  value={currentLocal.nom}
                  onChange={(e) => setCurrentLocal({...currentLocal, nom: e.target.value})}
                  placeholder="Ex: ATELIER MECANIQUE, RESERVE..."
                  className="form-input"
                  autoFocus
                />
              </div>
              <div className="form-group">
                <label className="form-label">Description (optionnelle)</label>
                <textarea
                  value={currentLocal.description}
                  onChange={(e) => setCurrentLocal({...currentLocal, description: e.target.value})}
                  rows={3}
                  placeholder="Description du local..."
                  className="form-textarea"
                />
              </div>
            </div>
            <div className="modal-footer">
              <button onClick={() => setShowLocalModal(false)} className="cancel-button">
                Annuler
              </button>
              <button onClick={handleSaveLocal} disabled={!currentLocal.nom.trim()} className="save-button">
                {editingLocalIndex !== null ? 'Mettre à jour' : 'Ajouter'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* MODALS ÉQUIPEMENTS */}
      {showCategoryModal && selectedLocal && (
        <EquipmentCategoryModal
          isOpen={showCategoryModal}
          onClose={() => {
            setShowCategoryModal(false);
            setSelectedLocal(null);
            setSelectedCategory(null);
          }}
          local={selectedLocal}
          onSelectCategory={handleSelectCategory}
        />
      )}

      {showObservationModal && (
        <ObservationModal
          isOpen={showObservationModal}
          onClose={handleCloseObsModal}
          onSave={handleSaveObservation}
          context={observationContext}
          initialPhotos={obsInitialPhotos}
          mission={mission}
          missionId={mission?.id}
        />
      )}

      {showArretUrgenceModal && (
        <EssaiArretUrgenceModal
          isOpen={showArretUrgenceModal}
          onClose={() => setShowArretUrgenceModal(false)}
          mission={mission}
        />
      )}

      {showImportModal && (
        <ImportLocalisationsModal
          isOpen={showImportModal}
          onClose={() => setShowImportModal(false)}
          onImport={handleImport}
        />
      )}

      {showDuplicateModal && duplicatingLocal && (
        <DuplicateLocalModal
          isOpen={showDuplicateModal}
          onClose={() => {
            setShowDuplicateModal(false);
            setDuplicatingLocal(null);
          }}
          local={duplicatingLocal.local}
          onDuplicate={handleDuplicateLocal}
        />
      )}

      {selectedCategory === 'luminaire' && selectedLocal && (
        <LuminaireModal
          isOpen={true}
          onClose={handleCloseEquipmentModal}
          onSave={handleSaveEquipment}
          local={selectedLocal}
          equipment={editingEquipment}
        />
      )}

      {selectedCategory === 'eclairage_securite' && selectedLocal && (
        <EclairageSecuriteModal
          isOpen={true}
          onClose={handleCloseEquipmentModal}
          onSave={handleSaveEquipment}
          local={selectedLocal}
          equipment={editingEquipment}
        />
      )}

      {selectedCategory === 'prise_courant' && selectedLocal && (
        <PriseCourantModal
          isOpen={true}
          onClose={handleCloseEquipmentModal}
          onSave={handleSaveEquipment}
          local={selectedLocal}
          equipment={editingEquipment}
        />
      )}

      {selectedCategory === 'materiel_informatique' && selectedLocal && (
        <MaterielInfoModal
          isOpen={true}
          onClose={handleCloseEquipmentModal}
          onSave={handleSaveEquipment}
          local={selectedLocal}
          equipment={editingEquipment}
        />
      )}

      {selectedCategory === 'materiel_amovible' && selectedLocal && (
        <MaterielAmovibleModal
          isOpen={true}
          onClose={handleCloseEquipmentModal}
          onSave={handleSaveEquipment}
          local={selectedLocal}
          equipment={editingEquipment}
        />
      )}

      {selectedCategory === 'recepteurs_fixes' && selectedLocal && (
        <RecepteursFixesModal
          isOpen={true}
          onClose={handleCloseEquipmentModal}
          onSave={handleSaveEquipment}
          local={selectedLocal}
          equipment={editingEquipment}
        />
      )}

      {selectedCategory === 'materiel_portatif' && selectedLocal && (
        <MaterielPortatifModal
          isOpen={true}
          onClose={handleCloseEquipmentModal}
          onSave={handleSaveEquipment}
          local={selectedLocal}
          equipment={editingEquipment}
        />
      )}

      {selectedCategory === 'machine_garage' && selectedLocal && (
        <MachineGarageModal
          isOpen={true}
          onClose={handleCloseEquipmentModal}
          onSave={handleSaveEquipment}
          local={selectedLocal}
          equipment={editingEquipment}
        />
      )}

      {selectedCategory === 'materiel_industriel' && selectedLocal && (
        <MaterielIndustrielModal
          isOpen={true}
          onClose={handleCloseEquipmentModal}
          onSave={handleSaveEquipment}
          local={selectedLocal}
          equipment={editingEquipment}
        />
      )}

      {selectedCategory === 'machine_ce' && selectedLocal && (
        <MachineCEModal
          isOpen={true}
          onClose={handleCloseEquipmentModal}
          onSave={handleSaveEquipment}
          local={selectedLocal}
          equipment={editingEquipment}
        />
      )}

      {selectedCategory === 'ddr_circuits_terminaux' && selectedLocal && (
        <DDRCircuitsTerminauxModal
          isOpen={true}
          onClose={handleCloseEquipmentModal}
          onSave={handleSaveEquipment}
          local={selectedLocal}
          equipment={editingEquipment}
        />
      )}

      {selectedCategory === 'autre' && selectedLocal && (
        <AutreEquipementModal
          isOpen={true}
          onClose={handleCloseEquipmentModal}
          onSave={handleSaveEquipment}
          local={selectedLocal}
          equipment={editingEquipment}
        />
      )}
    </div>
  );
}